import gql from 'graphql-tag';
import { apollo } from 'src/features';

const mutation = gql`
mutation updateAppealId($activityId: ID!, $appealId: String!) {
  updateAppealId(activityId: $activityId, appealId: $appealId){
    id
    appealId
  }
}`;

function updateAppealId(activityId, appealId) {
  return apollo.client.mutate({
    variables: {
      activityId,
      appealId,
    },
    mutation,
  }).then((res) => res.data.updateAppealId);
}

export default updateAppealId;
